import { Col, PageWrapper, Row } from '@qonsoll/react-design'
import { HeaderBreadcrumbs, PageActions, Spinner } from 'components'
import {
  useGetNewsTipInitialValues,
  useNewsTipBaseActions
} from 'domains/NewsTip/hooks'

import { NewsTipAdvancedView } from 'domains/NewsTip/components'
import { STATUSES } from '__constants__'
import { useParams } from 'react-router-dom'
import { useTranslations } from 'contexts/Translation'

const NewsTipShowPage = () => {
  /* Getting translations instance */
  const { t } = useTranslations()
  /* Getting params from router */
  const { newsTipId } = useParams()

  /* Fetching news tip data from useGetNewsTipInitialValues hook */
  const [newsTipData, loading] = useGetNewsTipInitialValues(newsTipId)
  /* Get actions for page */
  const actions = {
    copy: true,
    download: true,
    edit: newsTipData?.newsTip?.status === STATUSES.NEWS_TIP_STATUSES.APPROVED
  }
  const { onBack, onEdit, onCopy, onDownload } = useNewsTipBaseActions({
    newsTipId: newsTipId,
    actions,
    extraProps: newsTipData
  })

  /* Configuring page header */
  const headingProps = {
    title: newsTipData?.title || t('News tip show'),
    titleSize: 3,
    marginBottom: 3,
    textAlign: 'left'
  }
  const handleDownloadFiles = () => {
    const { newsTip } = newsTipData
    const { videoUrl = null, photoUrls = [], title } = newsTip
    const computedUrls = [...photoUrls, videoUrl]?.filter(Boolean)

    return onDownload(computedUrls, title)
  }

  const isTipsFromGuest = !newsTipData?.newsTip?._createdBy

  return (
    <PageWrapper
      action={
        <PageActions
          editTooltip={
            isTipsFromGuest
              ? t('Impossible to edit tip that was created by guest')
              : null
          }
          editButtonProps={{ disabled: isTipsFromGuest }}
          onDownload={handleDownloadFiles}
          actions={actions}
          onEdit={onEdit}
          onCopy={onCopy}
        />
      }
      onBack={onBack}
      breadcrumbs={<HeaderBreadcrumbs />}
      headingProps={headingProps}>
      <Row noGutters>
        {loading ? (
          <Col>
            <Spinner height="70vh" text={t('News tip loading')} />
          </Col>
        ) : (
          <Col cw={12}>
            <NewsTipAdvancedView {...newsTipData} />
          </Col>
        )}
      </Row>
    </PageWrapper>
  )
}

export default NewsTipShowPage
